import Q6_3_GiantDog from ".//Q6_3_GiantDog.svg";
import Q6_3_LargeDog from ".//Q6_3_LargeDog.svg";
import Q6_3_MediumDog from ".//Q6_3_MediumDog.svg";
import Q6_3_SmallDog from ".//Q6_3_SmallDog.svg";
import aboutYouIntro from "./aboutYouIntro.json";
import aboutYouPayoff from "./aboutYouPayoff.json";
import choosingYourDogIntro from "./choosingYourDogIntro.json";
import choosingYourDogPayoff from "./choosingYourDogPayoff.json";
import dogProgress from "./dogProgress.json";
import dogProgressSit from "./dogProgressSit.json";
import endOfSurvey from "./endOfSurvey.json";
import relationshipWithYourDogIntro from "./relationshipWithYourDogIntro.json";
import relationshipWithYourDogPayoff from "./relationshipWithYourDogPayoff.json";
import thoughtsOnDogsIntro from "./thoughtsOnDogsIntro.json";
import thoughtsOnDogsPayoff from "./thoughtsOnDogsPayoff.json";
import tooltipAnimated from "./tooltipAnimated.json";
import tooltipSmall from "./tooltipSmall.json";
import understandingYourDogIntro from "./understandingYourDogIntro.json";
import understandingYourDogPayoff from "./understandingYourDogPayoff.json";
import warmIntro from "./warmIntro.json";
import warmPayoff from "./warmPayoff.json";

import aboutYou2024 from "./2024/aboutYou.json";
import aboutYourDog2024 from "./2024/aboutYourDog1.json";
import crisis2024 from "./2024/crisis.json";
import numberOfDogs2024 from "./2024/numberOfDogs1.json";
import numberOfDogs22024 from "./2024/numberOfDogs2.json";
import outAndAbout2024 from "./2024/outAndAbout.json";
import readingYourDog2024 from "./2024/readingYourDog.json";
import welfare2024 from "./2024/welfare.json";
import wellbeing2024 from "./2024/wellbeing.json";

// Local storage
export const THANK_YOU_STATUS = "THANK_YOU_STATUS";

// Media
export const ANIMATIONS_2024 = {
	aboutYou2024,
	aboutYourDog2024,
	crisis2024,
	numberOfDogs2024,
	numberOfDogs22024,
	outAndAbout2024,
	readingYourDog2024,
	welfare2024,
	wellbeing2024,
};
export const ndsQ6_3_DogSizeImages = [
	Q6_3_SmallDog,
	Q6_3_MediumDog,
	Q6_3_LargeDog,
	Q6_3_GiantDog,
];

export const INTRO_ANIMATIONS: Partial<Record<NDS.RouteName, object>> = {
	ABOUT_YOU: aboutYouIntro,
	CHOOSING_YOUR_DOG: choosingYourDogIntro,
	ABOUT_YOUR_DOGS: warmIntro, // TODO - confirm this is ok?
	RELATIONSHIP_WITH_YOUR_DOG: relationshipWithYourDogIntro,
	THOUGHTS_ON_DOGS: thoughtsOnDogsIntro,
	UNDERSTANDING_YOUR_DOG: understandingYourDogIntro,
	WARM: warmIntro,
};

// biome-ignore lint/suspicious/noExplicitAny: Legit any
export const PAYOFF_ANIMATIONS: Partial<Record<NDS.RouteName, any>> = {
	ABOUT_YOU: aboutYouPayoff,
	CHOOSING_YOUR_DOG: choosingYourDogPayoff,
	ABOUT_YOUR_DOGS: warmPayoff, // TODO - confirm this is ok?
	RELATIONSHIP_WITH_YOUR_DOG: relationshipWithYourDogPayoff,
	THOUGHTS_ON_DOGS: thoughtsOnDogsPayoff,
	UNDERSTANDING_YOUR_DOG: understandingYourDogPayoff,
	WARM: warmPayoff,
	GLOBAL: {
		END_OF_SURVEY: endOfSurvey,
	},
};

export {
	tooltipSmall,
	tooltipAnimated,
	aboutYouIntro,
	aboutYouPayoff,
	choosingYourDogIntro,
	choosingYourDogPayoff,
	dogProgress,
	dogProgressSit,
	endOfSurvey,
	relationshipWithYourDogIntro,
	relationshipWithYourDogPayoff,
	thoughtsOnDogsIntro,
	thoughtsOnDogsPayoff,
	understandingYourDogIntro,
	understandingYourDogPayoff,
	warmIntro,
	warmPayoff,
};
